"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStaticContainer = _interopRequireDefault(require("react-static-container"));

var _ReadyState = _interopRequireDefault(require("./ReadyState"));

var FetchReadyStateRenderer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FetchReadyStateRenderer, _Component);

  function FetchReadyStateRenderer() {
    (0, _classCallCheck2.default)(this, FetchReadyStateRenderer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FetchReadyStateRenderer).apply(this, arguments));
  }

  (0, _createClass2.default)(FetchReadyStateRenderer, [{
    key: "renderChildrenIfNeeded",
    value: function renderChildrenIfNeeded() {
      var _this$props = this.props,
          children = _this$props.children,
          error = _this$props.error,
          readyState = _this$props.readyState,
          renderFailure = _this$props.renderFailure,
          renderSuccess = _this$props.renderSuccess,
          renderLoading = _this$props.renderLoading;

      if (readyState === _ReadyState.default.PENDING || readyState === _ReadyState.default.LOADING) {
        if (renderLoading) {
          return renderLoading();
        }
      } else if (readyState === _ReadyState.default.FAILURE) {
        if (renderFailure) {
          return renderFailure(error);
        }
      } else if (readyState === _ReadyState.default.SUCCESS) {
        if (renderSuccess) {
          return renderSuccess();
        }

        return children;
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.renderChildrenIfNeeded();
      var shouldUpdate = true;

      if (typeof children === 'undefined') {
        shouldUpdate = false;
        children = null;
      }

      return _react.default.createElement(_reactStaticContainer.default, {
        shouldUpdate: shouldUpdate
      }, children);
    }
  }]);
  return FetchReadyStateRenderer;
}(_react.Component);

FetchReadyStateRenderer.displayName = 'FetchReadyStateRenderer';
FetchReadyStateRenderer.propTypes = {
  children: _propTypes.default.node,
  error: _propTypes.default.any,
  readyState: _propTypes.default.oneOf([_ReadyState.default.FAILURE, _ReadyState.default.LOADING, _ReadyState.default.PENDING, _ReadyState.default.SUCCESS]).isRequired,
  renderFailure: _propTypes.default.func,
  renderLoading: _propTypes.default.func,
  renderSuccess: _propTypes.default.func
};
var _default = FetchReadyStateRenderer;
exports.default = _default;